import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/sales/return/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
    return request({
      url: "/sales/return/saveOrUpdate",
      method: "post",
      data,
    });
  }

  export function get(id) {
    return request({
      url: "/sales/return/get",
      method: "get",
      params: { id },
    });
  }
export function deleteById(id) {
    return request({
      url: "/sales/return/deleteById",
      method: "post",
      data: { id: id },
    });
  }
  // 根据销售组织返回客户
  export function getByCustomerApply(data) {
    return request({
      url: "/customer/customerApply/getByCustomerApply",
      method: "post",
      data
    });
  }
  // 根据销售组织查询中间公司
  export function getByMiddleCompany(data) {
    return request({
      url: "/base/company/getByCompanyOfTransaction",
      method: "post",
      data
    });
  }
  //
  export function submit(id) {
    return request({
      url: "/sales/return/submit",
      method: "post",
      data: { id: id },
    });
  }
  export function getDetailedDataPopup(condition, pagination) {
    return request({
      url: "/crm/sales/line/returnPage",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  export function getSalesOrder(condition, pagination) {
    return request({
      url: "/sales/return/getBySalesOder",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }

